import axios, { AxiosError } from "axios";
import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { ILoginRequestUser, Loadmetype } from "./usertypes";
import jwtDecode, { JwtPayload } from "jwt-decode";

import qs from "qs";
import { resolveTripleslashReference } from "typescript";

const loginAxios = axios.create({
  baseURL: "https://www.farminsf.com",
});

export interface JwtPayloads {
  preferred_username: string;
}

export const LoginAct = createAsyncThunk(
  "user/Login",
  async (data: ILoginRequestUser, { rejectWithValue }) => {
    try {

      switch (data.userId) {
        case 'won1' : 
        case 'bang1' : 
        case 'slife1' : 
        case 'suhwooms1' : 
        case 'test111' :

          if (data.password == data.userId + '!') {

            localStorage.setItem("accessToken", data.userId);
            localStorage.setItem("refreshToken", data.userId);

            return await new Response(
              JSON.stringify(
                { userId: data.userId }
              ),
              { 
                status: 200, 
                headers: { "Content-Type": "application/json" } 
              }
            ).json();

          }
          else {
            throw new Error("로그인 실패");
          }

          break;

        default : throw new Error("로그인 실패");
      }


    } catch (error: any) {
      console.error(error);

      return rejectWithValue(error.message);
    }
  }
);

export const Logout = createAsyncThunk(
  "user/Logout",
  async (data, { rejectWithValue }) => {
    try {
      return "logout";
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const Loadme = createAsyncThunk(
  "user/Loadme",
  async (data: Loadmetype, { rejectWithValue }) => {
    try {
      return data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const settingUser = createAsyncThunk(
  "user/settingUser",
  async (data: null, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/ifactory/api/member/findmemberinfo`);
      return response.data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.response.data);
    }
  }
);
